import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgShieldStar = (props: SvgProps) => (
  <Svg width={30} height={36} fill="none" {...props}>
    <Path
      fill={props.color}
      d="M1.781 2.988 15.227 0l13.446 2.988a1.64 1.64 0 0 1 1.282 1.597v16.342a9.82 9.82 0 0 1-4.373 8.17L15.227 36 4.872 29.096A9.82 9.82 0 0 1 .5 20.93V4.585a1.636 1.636 0 0 1 1.281-1.597m13.446 17.467 4.81 2.528-.918-5.355 3.89-3.793-5.376-.782-2.406-4.871-2.405 4.871-5.376.782 3.89 3.793-.916 5.355z"
    />
  </Svg>
);
const Memo = memo(SvgShieldStar);
export default Memo;
